import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { SET_USER_INFO } from 'state/global/auth/action';
import { getUserInfo } from 'util/auth';

export const useAuth = () => {
  const [authInfo, setAuthInfo] = useState({
    isCheckingAuth: true,
    isLoggedIn: false
  });
  const dispatch = useDispatch();

  const checkAuthentication = useCallback(async () => {
    const userInfo = await getUserInfo();
    setAuthInfo({
      isCheckingAuth: false,
      isLoggedIn: !!userInfo
    });

    // Update auth store
    if (userInfo) {
      dispatch({
        type: SET_USER_INFO,
        payload: userInfo?.idToken?.payload
      });
    }
  }, [dispatch]);

  useEffect(() => {
    checkAuthentication();
  }, [checkAuthentication, dispatch]);

  return [authInfo.isCheckingAuth, authInfo.isLoggedIn];
};
